import { fetchApi } from "./fetchApi";

export const dropdownValueApi = {
  async create(data) {
    const { dropdownId } = data;
    const response = await fetchApi({
      data,
      method: "post",
      url: `/api/dropdown/${dropdownId}/dropdownValue`,
    });

    return response.data.result;
  },

  async get(dropdownId, id) {
    return fetchApi({
      method: "get",
      url: `/api/dropdown/${dropdownId}/dropdownValue/${id}`,
    });
  },

  async list(dropdownId) {
    const response = await fetchApi({
      method: "get",
      url: `/api/dropdown/${dropdownId}/dropdownValue`,
    });
    return response;
  },

  async listWithReleaseNotes(dropdownId) {
    const response = await fetchApi({
      method: "get",
      url: `/api/dropdown/${dropdownId}/dropdownValue?includeReleaseNotes=true`,
    });
    return response;
  },

  async remove({ dropdownId, id }) {
    await fetchApi({
      method: "delete",
      url: `/api/dropdown/${dropdownId}/dropdownValue/${id}`,
    });
  },

  async update(dropdownValue) {
    const data = Object.assign({}, dropdownValue);
    const { dropdownId, id } = data;
    delete data.id;

    const response = await fetchApi({
      data,
      method: "put",
      url: `/api/dropdown/${dropdownId}/dropdownValue/${id}`,
    });

    return response.data.result;
  },
};
